export enum CardsDeliveryStatus {
  All = 'all',
  Ordered = 0, // INITIATED
  OutForDelivery = 1, // PENDING
  Delivered = 2,
  Returned = 3,
}

export const AddressTypeLabels = [
  'Not Set',
  'Home',
  'Office',
  'Other',
];

export const PaymentMethodsLabels = {
  F: 'Fawry',
  P: 'Paymob',
};

export const StatusLabels = [
  'Ordered',
  'Out For Delivery',
  'Delivered',
  'Returned',
];

export interface AddressDetailsProps {
  handleClose: () => void;
  modalOpen: boolean;
  requestId: number;
}

export interface AddressDetails {
  address: string;
  addressNotes: string;
  addressType: number;
  name: string;
  phone: string;
  coordinateLat: string;
  coordinateLong: string;
  day: string;
  timeRange: any;
}

export const initialAddress: AddressDetails = {
  address: '',
  addressNotes: '',
  addressType: 0,
  coordinateLat: '',
  coordinateLong: '',
  name: '',
  phone: '',
  day: '',
  timeRange: '',
};

export enum CardRequestType {
  BranchPickup = 'pickup',
  HomeDelivery = 'delivery',
}
